// 新手引导关卡数据
import request from '@/utils/request';
export function levelDetails(data) {
  return request({
    url: '/data/level_details',
    method: 'get',
    params: data
  });
}